'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StreamBox;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StreamBox(_ref) {
  var name = _ref.name,
      selected = _ref.selected,
      selectStream = _ref.selectStream,
      streamId = _ref.streamId,
      thumbnailUrl = _ref.thumbnailUrl,
      index = _ref.index;

  var overlayStyle = _style2.default.angleBoxOverlay;
  if (selected) {
    overlayStyle += ' ' + _style2.default.angleBoxSelected;
  }

  var thumb = thumbnailUrl ? _react2.default.createElement('img', { className: _style2.default.angleBoxThumb, src: thumbnailUrl, title: name }) : _react2.default.createElement('div', { className: _style2.default.angleBoxThumb });

  // this static class is to make it work with react-onclickoutside
  // since on intial render these aren't rendered, the HOC doesn't pick up on these
  // nodes and thinks they are "outside"
  var className = 'ignore-react-onclickoutside ' + _style2.default.angleBoxContainer;
  var displayName = name || 'Angle ' + (index + 1);

  return _react2.default.createElement(
    'div',
    { className: className, onClick: function onClick() {
        return selectStream(streamId, name);
      } },
    _react2.default.createElement(
      'p',
      { className: _style2.default.angleBoxLabel },
      displayName
    ),
    _react2.default.createElement('div', { className: overlayStyle }),
    thumb
  );
}

StreamBox.propTypes = {
  name: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  selectStream: _propTypes2.default.func,
  streamId: _propTypes2.default.string,
  thumbnailUrl: _propTypes2.default.string,
  index: _propTypes2.default.number
};
module.exports = exports['default'];